// HandleResponse uses createAsyncThunk's fulfillWithValue. When a thunk needs
// to inspect that result before its own payload creator returns, unwrap the
// RTK metadata wrapper first.
export const unwrapThunkResult = (value) => {
  if (value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "payload")) {
    return value.payload;
  }
  return value;
};

export default unwrapThunkResult;
